import { observer } from 'mobx-react'
import React, { ReactElement } from 'react'

import {
   API_FAILED,
   API_FETCHING,
   API_INITIAL
} from '@flowwai-frontend/shared/api-common'
import { FullScreenLoader } from '@flowwai-frontend/shared/common-components'

import useSsoLogin from '../../hooks/useSsoLogin'
import LoginController from '../LoginController/LoginController'

interface Props {
   ssoCode: string
}

const SsoExchangeController = (props: Props): ReactElement => {
   const { status } = useSsoLogin({ ssoCode: props.ssoCode })

   const renderContent = (): ReactElement => {
      switch (status) {
         case API_FAILED:
            return <LoginController />
         case API_INITIAL:
         case API_FETCHING:
         default:
            return <FullScreenLoader />
      }
   }

   return <>{renderContent()}</>
}

export default observer(SsoExchangeController)
